import {ModalContext} from '../components/ModalManager'
import {useContext, useEffect, useRef} from 'react'

// Global registry tracking all active titles
let titleStack = []

const updateBrowserTitle = () => {
  if (titleStack.length === 0) {
    document.title = 'BAYSIC'
    return
  }

  // LIFO from titleStack, it's sorted by priority,
  const highestPriority = titleStack[titleStack.length - 1]
  document.title = highestPriority ? highestPriority.title : 'BAYSIC'
}

export default ({title = 'BAYSIC'}) => {
  const isModal = useContext(ModalContext)
  const priority = isModal ? 2 : 1
  const instanceId = useRef(Math.random().toString()).current

  useEffect(() => {
    // Add or update the component's title in the stack
    titleStack = titleStack.filter(item => item.id !== instanceId)
    titleStack.push({id: instanceId, title, priority})
    // Stable sort ensures LIFO order is preserved for items with the same priority
    titleStack.sort((a, b) => a.priority - b.priority)
    updateBrowserTitle()

    // Automatically remove from the stack on unmount
    return () => {
      titleStack = titleStack.filter(item => item.id !== instanceId)
      updateBrowserTitle()
    }
  }, [title, priority, instanceId])
}
